export default __webpack_public_path__ + "static/media/AddToken.64c847f4.svg";